import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { convertAmount } from './utils';

export default function BaseTransactions({ data, basis }) {
    //console.log(data);
    //console.log(basis);

    if (!data) {
        return false;
    }

    // Base transactions are explicitly sorted newest-to-oldest (descending) by date.
    const isObRow = (row) => /^\d+$/.test(String(row[0]));
    const txRows = data.filter(row => !isObRow(row)).sort((a, b) => new Date(b[0]) - new Date(a[0]));
    
    // OB rows are reversed so entry "0" (consumed first by FIFO) sits at the absolute bottom.
    const obRows = data.filter(row => isObRow(row));
    // Sort OB rows by numeric index descending so "0" is at the very end
    obRows.sort((a, b) => parseInt(b[0]) - parseInt(a[0]));
    
    const displayData = [...txRows, ...obRows];

    return (
        <React.Fragment>
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table" id="base-transactions">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left"><b>Date</b></TableCell>
                            <TableCell align="left"><b>Description</b></TableCell>
                            <TableCell align="right"><b>{basis.foreign_currency}</b></TableCell>
                            <TableCell align="right"><b>Rate</b></TableCell>
                            <TableCell align="right"><b>{basis.functional_currency}</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayData.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                { /*<TableCell component="th" scope="row">
                                {row[0]}
                            </TableCell> */ }
                                <TableCell align="left">{row[0]}</TableCell>
                                <TableCell align="left">{row[1]}</TableCell>
                                <TableCell align="right">{convertAmount(row[2], 2)}</TableCell>
                                <TableCell align="right">{convertAmount(row[3], 6)}</TableCell>
                                <TableCell align="right">{convertAmount(row[4], 6)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <br></br>
        </React.Fragment>
    );
}
